export const headerCase = (strOrArray: string | string[]): string => {
  return (Array.isArray(strOrArray) ? strOrArray.join('-') : strOrArray)
    // Remplace tout séparateur non-lettre unicode ou chiffre par un tiret
    .replaceAll(/[^\p{L}0-9]+/gu, '-')
    // Remplace les tirets multiples par un seul tiret
    .replaceAll(/-+/g, '-')
    // Retire les tirets en début ou fin de chaîne
    .replaceAll(/(^-)|(-$)/g, '')
    // Découpe la chaîne sur les tirets
    .split('-')
    // Met la première lettre de chaque segment en majuscule, le reste en minuscule
    .map(word => word.length && word[0] ? word[0].toUpperCase() + word.slice(1).toLowerCase() : '')
    // Recolle les segments avec des tirets
    .join('-');
};

export const pluralize = (
  pattern: string,
  count: number,
  named: Record<string, string> = {},
  glue = '|',
): string | undefined => {
  // Découpe le pattern en différentes versions selon le séparateur (par défaut '|')
  const versions = pattern.split(glue).map(str => str.trim());
  // Prépare les variables à interpoler, dont 'n' pour le nombre
  const variables: Record<string, string> = { ...named, n: count.toString() };

  // Détermine l'index de la version à utiliser selon la valeur de count
  let index = 0;

  if (count === 1) {
    index = Math.min(1, versions.length - 1);
  } else if (count > 1) {
    index = Math.min(2, versions.length - 1);
  }

  // Remplace les variables dans la version choisie par leur valeur
  return versions[index]?.replaceAll(/{(\w+)}/g, (_: string, key: string) => variables[key] ?? `{${key}}`);
};

export const unaccent = (str: string): string => {
  return str
    .toLowerCase()
    // Décompose les caractères accentués
    .normalize('NFD')
    // Supprime les diacritiques
    .replaceAll(/\p{Diacritic}/gu, '');
};
